import React from 'react'
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";

class ProceedingsList extends React.Component {

    render() {

        const {data} = this.props;

        if (data.length === 0) {
            return (
                <div style={{paddingLeft: '30px', paddingRight: '30px'}}>
                    <br/>
                    <Alert severity="info">No se encontraron registros de actas para esta cuenta.</Alert>
                </div>
            );
        }

        return (
            <Grid container style={{paddingLeft: '50px', paddingRight: '50px'}}>
                {data.map((val, index) => {
                    return (
                        <Grid key={index} item xs={12}>
                            <Card style={{padding: '10px', marginBottom: '20px'}}>
                                <table className='custom-table'>
                                    <tbody>
                                    <tr>
                                        <th colSpan={4}>No. {val.NUMERO_ACTA}</th>
                                    </tr>
                                    <tr>
                                        <th>Fecha</th>
                                        <td>{val.FECHA_VISITA}</td>
                                        <th>Tipo</th>
                                        <td>{val.OBSER}</td>
                                    </tr>
                                    <tr>
                                        <th>Observación</th>
                                        <td colSpan={3} style={{textAlign: 'justify'}}>{val.AMPLIACION_OBSERVACION}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    }
}

export default ProceedingsList